import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ResponsiveContainer, PieChart, Pie, Legend, Cell, Tooltip } from 'recharts';
/**
 *
 * Display a pie chart visualization
 * @export
 */
const PieChartComponent = (props) => {
    let { data, fillColor, showLegend = false, className = '' } = props;
    // Get chart colors from CSS variables (theme colors)
    const getChartColor = (index) => {
        const colorIndex = (index % 15) + 1; // Cycle through chartColor1-15
        return `var(--chartColor${colorIndex})`;
    };
    const getFillColor = (entry, index) => {
        // Priority: item color > fillColor prop > theme chart colors
        if (typeof entry.color !== "undefined" && entry.color.trim().length > 0) {
            return entry.color;
        }
        if (fillColor && fillColor.trim().length > 0) {
            return fillColor;
        }
        return getChartColor(index);
    };
    return (_jsx("div", { className: `uxpcore_piechart ${className}`, children: _jsx(ResponsiveContainer, { className: 'uxpcore_chart__responsive-container', children: _jsxs(PieChart, { children: [_jsx(Pie, { data: data, labelLine: false, label: true, fill: fillColor || getChartColor(0), dataKey: "value", children: data.map((entry, index) => _jsx(Cell, { fill: getFillColor(entry, index) }, `cell-${index}`)) }), showLegend && _jsx(Legend, {}), _jsx(Tooltip, {})] }) }) }));
};
export default PieChartComponent;
